'use strict';

var HAS_CONCAT_BUG = require('../var/HAS_CONCAT_BUG'),
    arraySafeConcat = require('./arraySafeConcat');

function arrayConcat(arr1, arr2) {
  // istanbul ignore if
  if (HAS_CONCAT_BUG) {
    return arraySafeConcat(arr1, arr2);
  }
  return arr1.concat(arr2);
}

module.exports = arrayConcat;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/array/internal/arrayConcat.js
// module id = 387
// module chunks = 0